import { BaseEvent, PlainObject } from './types';
import BaseConfig from './BaseConfig';

export type RequestConfig = {
  url: string;
  method: 'post' | 'get';
  data: Object;
  header?: Record<string, any>;
};

export class BaseSender {
  config?: BaseConfig;

  commonParams: PlainObject = {};

  sensors: any = null;

  init(config: BaseConfig, commonParams: PlainObject, sensors: any) {
    this.config = config;
    this.commonParams = commonParams;

    this.sensors = sensors;

    if (this.sensors) {
      this.initSensors();
    }
  }

  /**
   * 初始化神策，不同平台初始化方式不同，需要继承修改
   */
  initSensors() {
    // @ts-ignore
    this.sensors.init(this.config!.sensorsConfig);
    setTimeout(() => {
      // @ts-ignore
      this.sensors.quick('autoTrack'); // 用于采集 $pageview 事件。
    }, 0);
  }

  /**
   * 上报到神策
   * @param event
   */
  sendSensors(eventInfo: BaseEvent) {
    const { event, ...params } = eventInfo;

    this.sensors && this.sensors.track && this.sensors.track(event, params);
  }

  /**
   * 发送请求方法，需要子类继承，不同平台实现方案不同
   * @param reqConfig
   */
  // @ts-ignore
  request(reqConfig: RequestConfig): Promise<any> {
    // todo 需要子类继承
    return Promise.resolve();
  }
}
